import type { JCodeAgentDiffs } from "../../../api/postCall/getAuthLetterAgentDiff";
import type {
  BasicInfoFieldState,
  DiagnosisDetailItemState,
  ProcedureFieldState,
} from "./constants";

const BASIC_FIELD_BY_API_NAME: Partial<
  Record<string, keyof BasicInfoFieldState>
> = {
  member_id: "memberId",
  provider: "providerName",
  auth_number: "authorizationId",
  auth_letter_auth_number: "authorizationId",
  auth_initiated_date: "authInitiatedDate",
  primary_insurance: "primaryInsurance",
  primary_insurance_plan_name: "primaryInsurance",
};

const PROCEDURE_FIELD_BY_API_NAME: Partial<
  Record<string, keyof ProcedureFieldState>
> = {
  auth_status: "authStatus",
  start_date: "startDate",
  end_date: "endDate",
  dosage: "dosage",
  units_approved: "unitsApproved",
  num_visits: "numVisits",
  calculated_visits: "numVisits",
  j_code: "cptCode",
  cpt_code: "cptCode",
  drug_name: "drugName",
  generic_name: "genericName",
  description: "drugName",
};

const DIAGNOSIS_FIELD_BY_API_NAME: Partial<
  Record<string, keyof DiagnosisDetailItemState>
> = {
  diagnosis_code: "diagnosisCode",
  auth_letter_icd_code: "diagnosisCode",
  icd_code: "diagnosisCode",
};

export function partitionAgentDiffsBySection(jCodeDiffs: JCodeAgentDiffs[]): {
  basicKeys: Set<keyof BasicInfoFieldState>;
  diagnosisKeys: Set<keyof DiagnosisDetailItemState>;
  procedureKeysByJCode: Record<string, Set<keyof ProcedureFieldState>>;
} {
  const basicKeys = new Set<keyof BasicInfoFieldState>();
  const diagnosisKeys = new Set<keyof DiagnosisDetailItemState>();
  const procedureKeysByJCode: Record<
    string,
    Set<keyof ProcedureFieldState>
  > = {};

  for (const row of jCodeDiffs) {
    const jc = row.j_code?.trim().toUpperCase() ?? "";
    if (!procedureKeysByJCode[jc]) {
      procedureKeysByJCode[jc] = new Set();
    }
    for (const d of row.diffs ?? []) {
      const name = d.field?.trim() ?? "";
      const basic = BASIC_FIELD_BY_API_NAME[name];
      if (basic) {
        basicKeys.add(basic);
        continue;
      }
      const diagnosis = DIAGNOSIS_FIELD_BY_API_NAME[name];
      if (diagnosis) {
        diagnosisKeys.add(diagnosis);
        continue;
      }
      const proc = PROCEDURE_FIELD_BY_API_NAME[name];
      if (proc) {
        procedureKeysByJCode[jc].add(proc);
      }
    }
  }

  return { basicKeys, diagnosisKeys, procedureKeysByJCode };
}
